const queryString = require('query-string');

function addParamsToUrlObject(location, params) {
  const parsed = queryString.parse(location.search);
  const newParams = {
    ...parsed,
    ...params
  }
  const newSearch = queryString.stringify(newParams);
  return {
    pathname: location.pathname,
    search: newSearch
  }
}

var UrlUtil = {
  // Generates a transcript URL preserving the current sub-page (coded-by-me, demographics, compare).
  // `pathname` is the current location pathname; `params` has { transcriptID, location }.
  getTranscriptUrl: function(pathname, params)
  {
    const { transcriptID, location } = params || {};
    const { search } = location || {};

    const isTranscriptPage = pathname && pathname.includes('/transcripts/');

    if (isTranscriptPage && !transcriptID)
      return '/transcripts';

    if (pathname && pathname.includes('/user/me')) {
      return `/transcripts/${transcriptID}/user/me`;
    } else if (pathname && pathname.includes('/demographics')) {
      return `/transcripts/${transcriptID}/demographics`;
    } else if (pathname && pathname.includes('/compare')) {
      // keep left and right if they are in search
      const { left, right } = queryString.parse(search);
      const newSearch = queryString.stringify({ left, right });
      return `/transcripts/${transcriptID}/compare${newSearch ? `?${newSearch}` : ''}`;
    }
    return `/transcripts/${transcriptID}`;
  },
  addParamsToUrlObject: addParamsToUrlObject,
  addParamsToUrl(url, params) {
    const urlObject = addParamsToUrlObject({
      pathname: url,
      search: ''
    }, params);

    return `${urlObject.pathname}?${urlObject.search}`;
  },
  setPage: function(page, location) {
    const parsed = queryString.parse(location.search);

    const queryParams = [
      parsed.left ? `left=${parsed.left}` : null,
      parsed.right ? `right=${parsed.right}` : null,
      `page=${page}`
    ].filter((param) => !!param).join('&');
    
    return `${location.pathname}?${queryParams}`;
  },
  getPageNumber: function(location) {
    const parsed = queryString.parse(location.search);
    return !!parsed.page && parseInt(parsed.page) ? parseInt(parsed.page) : 1;
  }
}

export default UrlUtil;
